import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";

// import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const CountryService = {
    getCountry,
    getCountryByID,
    createCountry,
    updateCountry,
    deleteCountry,
    getCountryAll
}


async function getCountry(projectID) {

    try {
        const response = await RestMethod.GET('/global-configuration/country?filter[status]=1');
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function getCountryAll(projectID) {

    try {
        const response = await RestMethod.GET('/global-configuration/country/all-country');
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getCountryByID(projectID, id) {
    try {
        const response = await RestMethod.GET('/global-configuration/country/' + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function createCountry(projectID, data) {
    try {
        const response = await RestMethod.POST('/global-configuration/country', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateCountry(projectID, id, data) {
    try {
        const response = await RestMethod.PUT('/global-configuration/country/' + id, data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function deleteCountry(projectID, id, data) {
    try {
        const response = await RestMethod.DELETE('/global-configuration/country/' + id, data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}
